import { setShowItemDescriptionModal } from '../State/showItemDescriptionModal';
import { setSelectedItemDescriptionId } from '../State/selectedItemDescriptionId';

export default () => async (dispatch) => {

  dispatch(setShowItemDescriptionModal(false));
  dispatch(setSelectedItemDescriptionId(null));

}